export const RolePlayer = "ROLE_PLAYER";
export const RolePlayerInactive = "ROLE_PLAYER_INACTIVE";
